








































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const root = namespace("root");

@Component({})
export default class selectTree extends Vue {
  @Prop({ default: "" }) customClass;
  @Prop({ default: false, type: Boolean }) disabled;
  @Prop({ type: String, default: "default" }) value;
  @Prop({ type: String, default: "" }) initOrgName;

  @Watch("value")
  handelValueChange() {
    this.init(this.value);
  }

  @root.Action queryOrganizationTree;
  @root.Action getOrganization;

  selectData: Array<any> = [];
  checked: any = {};
  loading: boolean = true;
  visible = false;
  allFirstDataList: any[] = [];
  page: number = 1;
  pageSize: number = 100;
  finish: boolean = false;
  isLoading: boolean = false;
  totalPage: number = 1;
  isInitDirty: boolean = false;
  searchOrgName = "";
  treeKey = new Date().getTime();

  @Watch("checked")
  watchChecked(val) {
    let { orgCode } = val;
  }

  async created() {
    this.init();
  }

  async getOrgName(orgCode) {
    try {
      let { orgName } = await this.getOrganization({
        orgCode
      });
      return orgName;
    } catch (error) {
      return "";
    }
  }

  async loadNode(node, resolve) {
    let result: Array<any> = [];
    if (node.level === 0) {
      let data: any = await this.getDefaultNode();
      let params: any = {
        orgParent: this.getOrgParent()
      };
      if (this.searchOrgName) {
        params.orgName = this.searchOrgName;
      }
      if (this.isInitDirty && this.initOrgName) {
        params.orgName = this.initOrgName;
      }
      let res = await this.queryOrganizationTree(params);
      this.isInitDirty = false;
      this.allFirstDataList = res;
      this.totalPage = Math.ceil(this.allFirstDataList.length / this.pageSize);

      result = [
        {
          ...data,
          children: res.slice(0, this.pageSize),
          haveChildren: res.length > 0
        }
      ];

      this.loading = false;
      this.$nextTick(() => {
        let $tree: any = this.$refs.tree;
        if (!$tree) return;
        if (res.length > 0) {
          let curNode = $tree.getNode(data.orgCode);
          curNode.expand();
        }
      });
    } else {
      if (node.data.children && node.data.children.length) {
        result = node.data.children;
      } else {
        result = await this.queryOrganizationTree({
          orgParent: node.data.orgCode
        });
      }
    }
    return resolve(result);
  }

  toggleTree() {
    this.visible = !this.visible;
    if (this.visible) {
      (this.$refs.tree as any).setCheckedKeys([this.checked.orgCode]);
    }
  }

  nodeClick(data, node, c) {
    let $tree: any = this.$refs.tree;
    $tree.setCheckedKeys([]);
    $tree.setCheckedKeys([data.orgCode]);
    let selectNode = $tree.getCurrentNode();
  }

  setOrgInfo(data, reload = false) {
    const { orgCode, orgName } = data;

    localStorage.setItem("org", orgCode);
    localStorage.setItem("orgInfo", JSON.stringify({ orgCode, orgName }));

    if (reload) {
      window.location.reload();
    }
  }

  cancelSelectOrg() {
    let $orgPickerTree = this.$refs.orgPickerTree;
    ($orgPickerTree as any).doClose();
  }

  async init(value = "") {
    this.isInitDirty = true;
    this.checked = {
      orgCode: value || this.value,
      orgName:
        this.value === "default"
          ? "Default"
          : await this.getOrgName(this.value || "default") // value为空，后端抛错，默认传default
    };
  }

  load() {
    if (this.isLoading || this.finish) return;
    this.isLoading = true;
    this.page++;

    let currentData = this.allFirstDataList.slice(
      (this.page - 1) * this.pageSize,
      this.page * this.pageSize
    );
    currentData.forEach(item => {
      (this as any).$refs.tree.append(item, "default");
    });
    if (this.totalPage === this.page) {
      this.finish = true;
    }
    this.isLoading = false;
  }

  async getDefaultNode() {
    return {
      orgCode: "default",
      orgName: "Default"
    };
  }

  getOrgParent() {
    return "root";
  }

  confirmSeletOrg() {
    let node = (this.$refs.tree as any).getCurrentNode();

    if (node && node.orgCode !== this.checked.orgCode) {
      this.checked = { orgCode: node.orgCode, orgName: node.orgName };

      this.$emit("input", node.orgCode);
      this.$emit("change", this.checked);
    }

    (this.$refs.orgPickerTree as any).doClose();
  }

  getCurrentBind() {
    return this.checked;
  }

  searchOrg() {
    this.allFirstDataList = [];
    this.page = 1;
    this.finish = false;
    this.isLoading = false;
    this.totalPage = 1;
    this.treeKey = new Date().getTime();
  }
}
